/* eslint-disable react/require-default-props */
import React, {
    useEffect, useRef, useContext,
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { AuthContext } from 'app/containers/AuthContainer';
import { DesignContext } from 'app/containers/DesignProvider';

import { Desktop } from 'app/components/Responsive';

import { SpaDesktopProfileHeader, SpaDesktopMenuHeader } from 'global/header/components/SpaDesktopHeader';

import './header.scss';
import Navigation from './components/Navigation';


const GlobalHeaderAdapter = () => {
    // Data
    const isProfile = window.location.pathname.includes('/profile');
    const isMenu = ['/menu/', '/basket/'].includes(window.location.pathname);
    // const { authData: { isAuthed } } = useContext(AuthContext);

    const { isAuthed } = useContext(AuthContext);

    const wrapperClassName = isProfile ? 'app-profile-header--wrapper' : 'app-header--wrapper';

    return (
        <div styleName={wrapperClassName}>
            {isProfile && <SpaDesktopProfileHeader isAuthed={isAuthed} />}
            {isMenu && <SpaDesktopMenuHeader isAuthed={isAuthed} />}
        </div>
    );
};

const Header = ({
    overlayIsOpen,
    isMobileNavigationOpen,
    onClickMobileNavigationButton,
    onClickMobileFilters = () => { },
    onClickBasketButton,
    onClickQuit,
    onClickBack,
    isMenuLocation,
    showFilterChangedAnimation,
    mainDishesCountState,
    onClickCloseSoldOutNotification,
    setDishesUpdatingState,
    isCategoryChanging,
    updateBilling,

    basketQuery = null,
    deliveryBasketQuery = null,
    isDeliveryMenuPage = false,
    isSoldOutNotificationVisible = false,
}) => {
    const authData = useContext(AuthContext);
    const {
        setHeaderHeight,
        headerHeight: savedHeaderHeight,
    } = useContext(DesignContext);

    const headerRef = useRef(null);

    useEffect(() => {
        const headerEl = headerRef.current;

        if (!headerEl) return;

        const height = headerEl.clientHeight;
        const isHeightChanged = height !== savedHeaderHeight;

        if (height && isHeightChanged) {
            setHeaderHeight(height);
        }
    });

    const spaHeaderRootClasses = classNames({
        'header__fixed-content': true,
        'profile-page-header': window.location.pathname.includes('/profile'),
    });

    // TODO: BR-1084 Profile header is here two ;))
    return (
        <div
            styleName={spaHeaderRootClasses}
            id="spaHeaderRef"
            // style={overlayIsOpen && isDesktop() ? { top: `${window.scrollY}px` } : {}}
            ref={headerRef}
        >
            <Desktop>
                <GlobalHeaderAdapter
                    isLinkHidden={isDeliveryMenuPage}
                    onClickQuit={onClickQuit}
                />
            </Desktop>
            <Navigation
                authData={authData}
                onClickBack={onClickBack}
                onClickQuit={onClickQuit}
                onClickMobileFilters={onClickMobileFilters}
                onClickBasketButton={onClickBasketButton}
                onClickMobileNavigationButton={onClickMobileNavigationButton}
                isMobileNavigationOpen={isMobileNavigationOpen}
                isNavigationHidden={isDeliveryMenuPage}
                basketQuery={deliveryBasketQuery || basketQuery}
                isMenuLocation={isMenuLocation}
                showFilterChangedAnimation={showFilterChangedAnimation}
                mainDishesCountState={mainDishesCountState}
                isSoldOutNotificationVisible={isSoldOutNotificationVisible}
                onClickCloseSoldOutNotification={onClickCloseSoldOutNotification}
                setDishesUpdatingState={setDishesUpdatingState}
                isCategoryChanging={isCategoryChanging}
                updateBilling={updateBilling}
            />
        </div>
    );
};

Header.propTypes = {
    overlayIsOpen: PropTypes.bool.isRequired,
    onClickMobileFilters: PropTypes.func,
    onClickBasketButton: PropTypes.func.isRequired,
    onClickQuit: PropTypes.func.isRequired,
    onClickMobileNavigationButton: PropTypes.func.isRequired,
    onClickBack: PropTypes.func.isRequired,
    isMobileNavigationOpen: PropTypes.bool.isRequired,
    isDeliveryMenuPage: PropTypes.bool,
    basketQuery: PropTypes.shape({}),
    deliveryBasketQuery: PropTypes.shape({}),
    isMenuLocation: PropTypes.bool.isRequired,
    showFilterChangedAnimation: PropTypes.bool.isRequired,

    mainDishesCountState: PropTypes.string.isRequired,
    isSoldOutNotificationVisible: PropTypes.bool,
    onClickCloseSoldOutNotification: PropTypes.func.isRequired,

    setDishesUpdatingState: PropTypes.func.isRequired,
    isCategoryChanging: PropTypes.bool.isRequired,

    updateBilling: PropTypes.func.isRequired,
};

export default Header;
